import { render, staticRenderFns } from "./Pets.vue?vue&type=template&id=a2b2b8fe&scoped=true&"
import script from "./Pets.vue?vue&type=script&lang=js&"
export * from "./Pets.vue?vue&type=script&lang=js&"
import style0 from "./Pets.vue?vue&type=style&index=0&id=a2b2b8fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b2b8fe",
  null
  
)

export default component.exports